import { render, staticRenderFns } from "./PartialItemsStatusChangePopUp.vue?vue&type=template&id=dcbe8f64&scoped=true&"
import script from "./PartialItemsStatusChangePopUp.vue?vue&type=script&lang=js&"
export * from "./PartialItemsStatusChangePopUp.vue?vue&type=script&lang=js&"
import style0 from "./PartialItemsStatusChangePopUp.vue?vue&type=style&index=0&id=dcbe8f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbe8f64",
  null
  
)

export default component.exports